var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"pb-2",staticStyle:{"min-width":"200px"},attrs:{"label":_vm.label,"value":_vm.filter.value,"hide-details":""},on:{"change":function($event){return _vm.checkboxSelected($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }